// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `.angular-cli.json`.

export const environment = {
  production: false,

  // api_url: 'http://localhost/business_license/public_service/ServiceRequest/',
  // auth_url: 'http://localhost/business_license/public_service/',
  // file_url: 'http://localhost/business_license/public_service/FileServiceRequest/'

  /*api_url: 'https://demo.globalwavetechnology.com/egovernment/mcdc/biz_license_public/pub_service/ServiceRequest/',
  auth_url: 'https://demo.globalwavetechnology.com/egovernment/mcdc/biz_license_public/pub_service/',
  file_url: 'https://demo.globalwavetechnology.com/egovernment/mcdc/biz_license_public/pub_service/FileServiceRequest/'*/

  /*api_url: 'http://app.mcdc.gov.mm/business_license/service/index.php/ServiceRequest/',
  auth_url: 'http://app.mcdc.gov.mm/business_license/service/index.php/',
  file_url: 'http://app.mcdc.gov.mm/business_license/service/index.php/FileServiceRequest/'*/

  api_url: 'https://app.nptdc.gov.mm/businesslicense/webapi/index.php/ServiceRequest/',
  auth_url: 'https://app.nptdc.gov.mm/businesslicense/webapi/index.php/',
  file_url: 'https://app.nptdc.gov.mm/businesslicense/webapi/index.php/FileServiceRequest/' 
};
